import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { Mousewheel, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import useStoriesModal from '@entities/Stories/hooks/useStoriesModal'
import { useStoriesStore } from '@entities/Stories/model'

import { useAllMarketingStoriesQuery } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

function SkeletonLoading () {
  const isTablet = useMediaQuery('(max-width: 767px)')

  return (
    <SkeletonTheme>
      <Skeleton
        className={styles.root__skeleton}
        count={1}
        style={{
          aspectRatio: '1 / 1',
          borderRadius: isTablet ? 8 : 16,
        }}
      />
    </SkeletonTheme>
  )
}

export default function PreviewStories () {
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { data, loading } = useAllMarketingStoriesQuery()
  const { isWatched, markAsWatched } = useStoriesStore()
  const { openStoriesModal } = useStoriesModal()

  const markWatch = (id: string) => {
    markAsWatched(id)
    openStoriesModal(id)
  }

  return (
    <div className={styles.root}>
      <Swiper
        className={cn('_navigation-center')}
        slidesPerView="auto"
        slidesPerGroup={1}
        modules={[ Mousewheel, Navigation ]}
        navigation={!isTablet}
        mousewheel={{ forceToAxis: true }}
        breakpoints={{
          0: {
            spaceBetween: 8,
          },
          767: {
            spaceBetween: 16,
          },
        }}
      >
        {data?.allMarketingStories?.edges?.map((item) => {
          return (
            <SwiperSlide className={styles.root__slide}>
              <div
                className={cn(styles.root__item, {
                  [styles.watched]: isWatched(item?.id as string),
                })}
                onClick={() => markWatch(item?.id as string)}
              >
                {item?.name && (
                  <h3 className={styles.root__title}>{item?.name}</h3>
                )}

                <img
                  className={styles.root__img}
                  src={item?.preview?.url as string}
                  alt={item?.name || ''}
                  loading="lazy"
                  fetchPriority="low"
                />
              </div>
            </SwiperSlide>
          )
        })}

        {!data &&
          loading &&
          Array.from({
            length: 8,
          }).map((_, index) => {
            return (
              <SwiperSlide className={styles.root__slide} key={index}>
                <SkeletonLoading />
              </SwiperSlide>
            )
          })}
      </Swiper>
    </div>
  )
}
